module.exports = __webpack_public_path__ + "img/202501160202.b195ff9b.png";